<template>
  <Navbar />
  <section class="main">
    <div class="container">
      <div class="col-12 position-relative">
        <div id="mainContentArea">
          <router-view />
        </div>
        <Loading />
        <div id="pageStatus" class="visually-hidden" role="status"></div>
      </div>
    </div>
  </section>
  <Footer />
</template>

<script setup>
import './scss/_global.scss'
import {useRoute, useRouter} from "vue-router"
import {nextTick, onMounted, watch} from "vue"
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Loading from './components/Loading'
import setAppName from "@/functions/setAppName"
import setAppYear from "@/functions/setAppYear"
import setRedirectUrl from "@/functions/setRedirectUrl"
import redirectToLogin from "@/functions/redirectToLogin"
import getLoading from "@/functions/getLoading"
import setServerType from "@/functions/setServerType"
import faqService from "@/functions/faqService"
import checkBrowserSupport from "@/functions/checkBrowserSupport"
import getUrlParameters from "@/functions/getUrlParameters"
import passkey from "@/functions/passkey"
import setPasskeyFeatureFlag from "@/functions/setPasskeyFeatureFlag";
import {user} from "@/functions/user";
import getAuthenticate from "@/functions/getAuthenticate";
import loadLoginHelpWidget from '@/functions/loadLoginHelpWidget'

const {checkPasskeyAvailability} = passkey()
const {handleAutoLogin} = getAuthenticate()
const { showLoading } = getLoading()
const { loadFaqs } = faqService()
setAppName()
setAppYear()
getUrlParameters()
setPasskeyFeatureFlag()
setRedirectUrl()
setServerType()
checkBrowserSupport()
checkPasskeyAvailability()

const router = useRouter()
const route = useRoute()

const linkablePages = [
	// 	auth pages
	'/',
	'/ReclaimAccount',
  '/about',
  '/NewUser',
  '/confirmEmail',
	'/preparer/login',
	'/preparer/create-preparer-account',
	'/preparer/verify-email',
	'/preparer/create-client-account',
	'/preparer/link-client-account',
	// account pages
	'/edit-username',
	'/edit-password',
	'/passkey',
	'/edit-security-settings-password',
	'/account-info',
	'/account-activity',
	'/edit-email',
	'/edit-second-email',
	'/edit-mobile-phone',
	'/confirm-delete-mobile-phone',
	'/login-sso',
	'/sso-callback',
	'/choose-username',
	'/partner-transfer',
]

onMounted(() => {
	// Own the widget at the app-shell level so it survives routed view changes.
	// Wait for the lazy initial route so the embed binds its first toast target.
	void router.isReady().then(() => nextTick()).then(loadLoginHelpWidget)
	user.bypassEmailCheck = JSON.parse(process.env.VUE_APP_DUPLICATE_EMAIL_BYPASS)
	if (sessionStorage.getItem('isValidBrowserOSConfig') === 'false') {
		showLoading()
		router.push('/browser-entry-denied' + window.location.search)
	}

	// Trigger autologin check on mount
	handleAutoLogin()

	if (location.pathname !== '/' && sessionStorage.getItem('faqs' + sessionStorage.getItem('appYear') + 'Loaded') !== 'true') {
		loadFaqs()
	}
})

watch(route, () => {
  if (route.path !== '/' && sessionStorage.getItem('faqs' + sessionStorage.getItem('appYear') + 'Loaded') !== 'true') {
    loadFaqs()
  }
})

const isPartnerRoute = location.pathname.startsWith('/partner/') && location.pathname.split('/').length === 3
if (linkablePages.includes(location.pathname) === false && !isPartnerRoute)
{
  redirectToLogin()
}

const goToLogin = () => {
  showLoading()
  router.go('/')
}

window.addEventListener("popstate", goToLogin);
</script>
